/**
 * Utility function to get user's IP address
 * Uses a third-party service to fetch the IP address
 */
export const getUserIP = async () => {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('Error fetching IP address:', error);
        // Fallback: return null if IP cannot be fetched
        return null;
    }
};
